import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, AppBar, IconButton, Typography, Toolbar, DialogContent } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const StandardDialog = props => {
    const { handleClose, open, title, children, fullScreen = true } = props
    return (
        <Dialog
            fullScreen = {fullScreen}
            aria-labelledby="simple-dialog-title"
            disableBackdropClick
            disableEscapeKeyDown
            onClose={handleClose}
            open={open} >
            <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
            <AppBar key={'dialog'}>
                <Toolbar style = {{ position: 'relative'}}>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" style = {{ flex: 1}}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent>
                { children }
            </DialogContent>
               
        </Dialog>
    );
};

StandardDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default StandardDialog;